module.exports = __webpack_public_path__ + "assets/images/36005a02f3f12e6b4c43ea413b03f6e2.png";